export class Settings {
    public static apiImagesUrl = "https://images.ctfassets.net";
    public static apiToken = "rRQ74x5fomLQyDCDE34So3KFjHfNMTjnzF-BeJ3GVzg";
    public static space = "g99jc76knswc";
    public static apiUrl = `https://cdn.contentful.com/spaces/${Settings.space}/environments/master/`;
}
